export default function (text_delta) {
  return (
    text_delta === undefined ||
    Object.keys(text_delta).length === 0 ||
    text_delta?.ops?.length === 0 ||
    text_delta?.ops?.[0]?.insert === '\n'
  );
}
